// @flow

import styled, { css } from 'styled-components';
import { media } from '../../helpers';
import type { Theme } from '../../types';

const Row = styled<any, Theme>('tr')`
  /* eslint-disable-line block-no-empty */
`;

const TitleRow = styled<any, Theme>('tr')`
  font-weight: bold;
  background-color: ${props => props.theme.table.titleRow.backgroundColor};
  font-size: 1.5rem;
  color: ${props => props.theme.table.titleRow.color};
`;

const ResponsiveRow = styled<typeof Row, Theme, _>(Row)`
  display: table-row;

  ${media.lg(css`
    display: none;
  `)}
`;

export {
  TitleRow,
  ResponsiveRow,
};

export default Row;
